import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ServicePackages from "./components/ServicePackages";
import Services from "./components/Services";
import PackageComparison from "./components/PackageComparison";
import VideoShowcase from "./components/VideoShowcase";
import Testimonials from "./components/Testimonials";
import HowWeOperate from "./components/HowWeOperate";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingCallButtons from "./components/FloatingCallButtons";
import PackageEnquiryModal from "./components/PackageEnquiryModal";
import QuoteModal from "./components/QuoteModal";

function HomePage() {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const handlePackageEnquire = (packageName) => {
    setSelectedPackage(packageName);
    setIsPackageModalOpen(true);
  };

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setIsQuoteModalOpen(true);
  };

  const handleClosePackageModal = () => {
    setIsPackageModalOpen(false);
    setSelectedPackage(null);
  };

  const handleCloseQuoteModal = () => {
    setIsQuoteModalOpen(false);
    setSelectedService(null);
  };

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Navbar onGetQuote={() => setIsPackageModalOpen(true)} />
      <Hero onGetQuote={() => setIsPackageModalOpen(true)} />
      <ServicePackages onEnquire={handlePackageEnquire} />
      <Services onServiceSelect={handleServiceSelect} />
      <PackageComparison />
      <VideoShowcase />
      <Testimonials />
      <HowWeOperate />
      <Contact />
      <Footer />
      <FloatingCallButtons />
      
      <PackageEnquiryModal
        isOpen={isPackageModalOpen}
        onClose={handleClosePackageModal}
        selectedPackage={selectedPackage}
      />
      
      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={handleCloseQuoteModal}
        preselectedService={selectedService}
      />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
